const Faq = () => import(/* webpackChunkName: "crm-faq" */ '@/pages/crm/faq/index.vue')

const CreateFaq = () =>
  import(/* webpackChunkName: "crm-faq" */ '@/pages/crm/faq/create.vue')

const EditFaq = () =>
  import(/* webpackChunkName: "crm-faq" */ '@/pages/crm/faq/edit.vue')

export default {
  path: 'faq',
  meta: {
    label: 'faq',
    auth: 'faq'
  },
  component: {
    name: 'Faq',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CrmFaqReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Faq
    },
    {
      name: 'CrmCreateFaq',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateFaq
    },
    {
      name: 'CrmEditFaq',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditFaq,
      props: true
    }
  ]
}
